import React from "react";
import Maincontent from "./Pages/Maincontent";

const Service = () => {
  return (
    <>
      <div className="serviceContent">
        <Maincontent />
      </div>
    </>
  );
};

export default Service;
